import { Component } from '@angular/core';
import { SearchComponent } from '../../icons/components/search.component';

@Component({
  selector: 'app-rule-management',
  templateUrl: './rule-management.component.html',
  styleUrls: ['./rule-management.component.css']
})
export class RuleManagementComponent {
  addModalOpened: boolean = false;
  deleteModalOpened: boolean = false;
  searchValue: string = '';
  emailValue: string = '';
  selectedType: string = 'Proxy';
  inputDisabled: boolean = false;
  
  startIcon = SearchComponent;

  handleSearch(): void {
    console.log('Searching for:', this.searchValue);
    // Implement search logic
  }

  handleSearchInputChange(value: string): void {
    this.searchValue = value;
    this.handleSearch();
  }

  handleEmailInputChange(value: string): void {
    this.emailValue = value;
  }

  handleChoose(type: string): void {
    this.selectedType = type;
  }

  handleCancel(): void {
    this.addModalOpened = false;
    this.resetForm();
  }

  handleAdd(): void {
    if (!this.emailValue) {
      // Show error message
      return;
    }
    
    // Add new rule logic here
    console.log('Adding new rule:', {
      email: this.emailValue,
      type: this.selectedType
    });
    
    this.addModalOpened = false;
    this.resetForm();
  }

  private resetForm(): void {
    this.emailValue = '';
    this.selectedType = 'Proxy';
  }

  setAddModalOpened(value: boolean): void {
    this.addModalOpened = value;
    if (!value) {
      this.resetForm();
    }
  }

  setDeleteModalOpened(value: boolean): void {
    this.deleteModalOpened = value;
  }

  setInputDisabled(isDisabled: boolean): void {
    this.inputDisabled = isDisabled;
  }
}